import { render } from "./EmailConfirm.vue?vue&type=template&id=744056cc&scoped=true"
import script from "./EmailConfirm.vue?vue&type=script&lang=js"
export * from "./EmailConfirm.vue?vue&type=script&lang=js"

import "./EmailConfirm.vue?vue&type=style&index=0&id=744056cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744056cc"]])

export default __exports__